var _path, _path2, _path3, _path4, _path5, _circle, _mask, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubheaderSupportDesk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 17H37.5M41.5 17H42.5M46.5 17H47.5",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 23V38C46.5 39.1046 45.6046 40 44.5 40H12.5C11.3954 40 10.5 39.1046 10.5 38V20C10.5 18.8954 11.3954 18 12.5 18H31.5",
    stroke: "#4F7FA7",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 14H11.5C8.73858 14 6.5 16.2386 6.5 19V44H50.5V22.9062",
    stroke: "#4F7FA7",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 42H53.5C53.5 44.2091 51.7091 46 49.5 46H7.5C5.29086 46 3.5 44.2091 3.5 42Z",
    fill: "#4F7FA7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 13C31.5 11.8954 32.3954 11 33.5 11H50.5C51.6046 11 52.5 11.8954 52.5 13V21.3684C52.5 22.473 51.6046 23.3684 50.5 23.3684H37.2219C36.1347 23.3684 35.1042 23.8539 34.4119 24.6922C33.4304 25.8808 31.5 25.1867 31.5 23.6453V13Z",
    stroke: "#4F7FA7",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 26,
    r: 3,
    stroke: "#4F7FA7",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-1_110_2396",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9613 29.0263L24.5 34L22.0387 29.0263C20.0468 29.255 18.5 30.9469 18.5 33V40H30.5V33C30.5 30.9469 28.9532 29.255 26.9613 29.0263Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 34L22.7075 34.8871L24.5 38.5092L26.2925 34.8871L24.5 34ZM26.9613 29.0263L27.1895 27.0394L25.7925 26.8789L25.1688 28.1392L26.9613 29.0263ZM22.0387 29.0263L23.8312 28.1392L23.2075 26.8789L21.8105 27.0394L22.0387 29.0263ZM18.5 40H16.5V42H18.5V40ZM30.5 40V42H32.5V40H30.5ZM26.2925 34.8871L28.7539 29.9134L25.1688 28.1392L22.7075 33.1129L26.2925 34.8871ZM20.2461 29.9134L22.7075 34.8871L26.2925 33.1129L23.8312 28.1392L20.2461 29.9134ZM20.5 33C20.5 31.9748 21.273 31.1274 22.2668 31.0132L21.8105 27.0394C18.8206 27.3827 16.5 29.9189 16.5 33H20.5ZM20.5 40V33H16.5V40H20.5ZM30.5 38H18.5V42H30.5V38ZM28.5 33V40H32.5V33H28.5ZM26.7332 31.0132C27.727 31.1274 28.5 31.9748 28.5 33H32.5C32.5 29.9189 30.1794 27.3827 27.1895 27.0394L26.7332 31.0132Z",
    fill: "#4F7FA7",
    mask: "url(#path-7-inside-1_110_2396)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubheaderSupportDesk);
export default __webpack_public_path__ + "static/media/subheader-support-desk.fd1b01fc907e44d08d736537670cb7f2.svg";
export { ForwardRef as ReactComponent };